export type Price = {
  value: number;
  unit: string;
  type: string;
};

export type SecondarySaleInfoPrice = {
  buyNowPrice: Price;
  lastPurchasedPrice: Price;
  makeOfferHighestPrice: Price;
  makeOfferLatestPrice: Price;
};

export type SecondarySaleInfo = {
  tokenStatus: string;
  price: SecondarySaleInfoPrice;
};

export interface Delivery {
  onChainTokenId: string;
  ownerWalletId: string;
  contractAddress: string;
}

export type CurrentBid = {
  currentBid: number;
  maximumBid: number;
  isCurrent: boolean;
  userId: string;
};

export type Bids = {
  id: string;
  currentBid: number;
  userId: string;
  createdAt: string;
  marketplaceUser: {
    username: string;
  };
  marketplaceAuctionLot: {
    id: string;
  };
};

export type MarketplaceAuctionLot = {
  id: string;
  startingBid: number;
  startDate: string;
  endDate: string;
  status: string;
  currentBid: CurrentBid;
  bids: Bids[];
};

export type MarketplaceBuyNowOutput = {
  id: string;
  unitPrice: number;
  totalUnits: number;
  startDate: string;
  endDate: string;
};

export type MarketplaceItemDetails = MarketplaceAuctionLot | MarketplaceBuyNowOutput;

export type NFTItem = {
  id: string;
  isBallot: boolean;
  collectionId: string;
  saleType: string;
  name: string;
  slug: string;
  status: string;
  secondarySaleInfo: SecondarySaleInfo;
  secondaryMarketplaceSalePrice: number;
  delivery: Delivery;
  allowList: { id: string }[];
  details: MarketplaceItemDetails;
};

export type NFTCollection = {
  id: string;
  marketplaceID: string;
  name: string;
  description: string;
  status: string;
  startDate: string;
  endDate: string;
  collectionType: string;
  itemsCount: number;
  items: NFTItem[];
};

export type CollectionBySlugData = {
  collectionBySlug: NFTCollection;
};

export enum FilterProps {
  ALL = 'ALL',
  UNSOLD = 'UNSOLD'
}

export type CollectionBySlugVars = {
  marketplaceID: string;
  slug: string;
  offset?: number;
  limit?: number;
  filter?: FilterProps;
};
